import { RouterProvider } from "react-router-dom";
import { router } from "router.jsx";
import "react-toastify/dist/ReactToastify.css";
import "@knocklabs/react/dist/index.css";
import "./styles/knock-overrides.less";
import "./styles-css/shadcn.css";
import "./styles-css/sked-ui-overrides.css";
import { useInitialUserData } from "@/hooks/useInitialUserData";
import { useVersionCheck } from "@/hooks/useVersionCheck";
import { FullPageLoading } from "@/components/ui/full-page-loading";
import { VersionUpdateModal } from "@/components/version-update-modal";
import { GlobalToastContainer } from "@/components/ui/toast";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { openModal } from "@/libs/modals";
import { BULK_CREATE_POST_MEDIA_SELECT_MODAL } from "@/features/post/bulk-create/bulk-create-post.actions";
export default function App(): JSX.Element {
  const { isLoading, isError, redirectTo } = useInitialUserData();
  const dispatch = useDispatch();
  const { isNewVersionAvailable, dismissUpdate, triggerReload, debugInfo } =
    useVersionCheck();

  useEffect(() => {
    if (redirectTo) {
      window.location.replace(redirectTo);
    } else if (isError) {
      window.location.replace("/signin");
    }
  }, [isError, redirectTo]);

  // Check URL parameters for auto-opening bulk create modal
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    if (params.get("autoOpenBulkCreate") === "true") {
      // Extract initialTab if provided
      const initialTab = params.get("initialTab") || undefined;

      // Open the modal
      dispatch(
        openModal({
          type: BULK_CREATE_POST_MEDIA_SELECT_MODAL,
          props: {
            initialTab,
          },
        })
      );
    }
  }, [dispatch]);

  // Show loading spinner while fetching initial user data
  if (isLoading) {
    return <FullPageLoading />;
  }

  // If user data fetch fails, send the user back to the signin SPA.
  if (isError) {
    return <FullPageLoading />;
  }

  return (
    <>
      <VersionUpdateModal
        open={isNewVersionAvailable}
        onDismiss={dismissUpdate}
        onReload={triggerReload}
        debugInfo={debugInfo}
      />
      <GlobalToastContainer />
      <RouterProvider router={router} />
    </>
  );
}
